import dayjs from "dayjs";
import { type MedicalHistorySlice } from "src/redux/slices/medicalHistorySlice";

import { sectionKeys } from "./defaultData";
import { getMedIdType } from "./getMedIdType";

const valueParser = (value: any, unit: string) => {
  if (unit === "date" || (unit === "day/month" && value))
    return value ? dayjs(value).format("YYYY-MM-DD") + " 00:00:00" : "";
  return value;
};

export const parseSaveData = (
  data: Record<string, any>,
  medData: MedicalHistorySlice,
) => {
  const { others, leaveHistory, patientInformation } = medData;
  const leaveHistoryData: any = {};
  leaveHistory.inputs.forEach(input => {
    const value = data[input.id];
    leaveHistoryData[input.name as any] = valueParser(value, input.unit);
  });

  patientInformation.inputs.forEach(input => {
    if (input.disabled) return;
    const value = data[input.id] || input.value;
    leaveHistoryData[input.name as any] = valueParser(value, input.unit);
  });

  const sections: any = {};

  sectionKeys.forEach(sectionKey => {
    const section = others.find(section => section.dataKey === sectionKey);
    if (!section) return;
    sections[sectionKey] = section.rows.map(row => {
      const rowData: any = {};
      row.inputs.forEach(input => {
        const value = data[input.id];

        if (input.name === "attachment") {
          if (value && (value.aid || value.type === "new")) {
            rowData[input.name] = value;
          }
          return;
        }

        rowData[input.name as any] = valueParser(value, input.unit);
      });
      const idType = getMedIdType(sectionKey);
      rowData[idType] = (row as any)[idType];
      return rowData;
    });
  });

  const parsedData = {
    ...leaveHistoryData,
    ...sections,
  };
  return parsedData;
};
